import GameStepBase from './game_step_base';


export default class RealityCheckIntervalAppenderGameStep extends GameStepBase {
    static CLASS = 'RealityCheckIntervalAppenderGameStep';

    run(gameOptions) {
        gameOptions.realityCheckInterval = gameOptions.company.getRealityCheckIntervalExpectedByTheGame();
        return Promise.resolve(gameOptions);
    }
}